import CustomMessage from './customMessage';
export default CustomMessage;
